var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _g5, _path7, _g6, _path8, _g7, _g8, _path9, _g9, _path0, _g0, _g1, _g10, _path1, _path10, _path11, _g11, _g12, _path12, _g13, _path13, _path14, _path15, _g14, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1387,
    height: 559,
    viewBox: "0 0 1387 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.801 416.1C234.801 418.2 236.501 419.9 238.601 419.9C240.701 419.9 242.401 418.2 242.401 416.1C242.401 414 240.701 412.3 238.601 412.3C236.501 412.3 234.801 414 234.801 416.1Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.8 417.3C211.567 417.3 213 415.867 213 414.1C213 412.333 211.567 410.9 209.8 410.9C208.032 410.9 206.6 412.333 206.6 414.1C206.6 415.867 208.032 417.3 209.8 417.3Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.8 394.5H239.3L244 374.8H204L208.8 394.5Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2 415.5L233.6 410.9H208C205.8 410.9 204.1 409.1 204.1 407C204.1 404.8 205.9 403.1 208 403.1H237.4L247.4 361H257.1",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.401 381.1H216.801",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9 387.7H224",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1140.26 415.996C1140.26 418.092 1138.56 419.789 1136.46 419.789C1134.37 419.789 1132.67 418.092 1132.67 415.996C1132.67 413.9 1134.37 412.203 1136.46 412.203C1138.56 412.203 1140.26 413.9 1140.26 415.996Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.21 417.194C1163.45 417.194 1162.02 415.764 1162.02 414C1162.02 412.236 1163.45 410.806 1165.21 410.806C1166.98 410.806 1168.41 412.236 1168.41 414C1168.41 415.764 1166.98 417.194 1165.21 417.194Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.21 394.437H1135.77L1131.08 374.774H1171L1166.21 394.437Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.86 415.397L1141.46 410.806H1167.01C1169.2 410.806 1170.9 409.009 1170.9 406.913C1170.9 404.717 1169.1 403.021 1167.01 403.021H1137.66L1127.68 361H1118",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.67 381.062H1158.22",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.17 387.649H1151.04",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.3992 72.6L79.1992 109C78.6992 112.4 75.7992 114.9 72.3992 114.9H72.1992V72.8L76.1992 72.5H84.3992V72.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.598 62.7001C108.598 67.5001 104.698 71.4001 99.998 71.4001V54.1001C104.698 54.1001 108.598 58.0001 108.598 62.7001Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2984 44.3003V81.2003C95.2984 78.8003 94.3984 76.7003 92.7984 75.1003C91.2984 73.6003 89.0984 72.6003 86.6984 72.6003H71.2984C65.7984 72.6003 61.3984 68.2003 61.3984 62.7003C61.3984 60.0003 62.4984 57.5003 64.2984 55.7003C66.0984 53.9003 68.5984 52.8003 71.2984 52.8003H86.6984C91.3984 52.8003 95.2984 49.0003 95.2984 44.3003Z",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3984 52.8003V72.1003",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9992 42.0002V82.8002C99.9992 84.1002 98.8992 85.2002 97.5992 85.2002C96.2992 85.2002 95.1992 84.1002 95.1992 82.8002V42.0002C95.1992 40.7002 96.2992 39.7002 97.5992 39.7002C98.1992 39.7002 98.7992 40.0002 99.2992 40.4002C99.6992 40.8002 99.9992 41.4002 99.9992 42.0002Z",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.498 37.8L136.098 32",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.799 51.1998L121.899 42.7998",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5 54.1001L113.1 58.4001",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4 44.1001L129 50.3001",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.498 86.8999L136.098 92.6999",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.799 73.5L121.899 81.9",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5 70.5998L113.1 66.2998",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4 80.5999L129 74.3999",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.498 62.3999H123.598",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.998 62.3999H139.798",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.299 62.5H150.699",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.098 47.1996C163.098 48.5996 161.898 49.7996 160.498 49.7996C159.098 49.7996 157.898 48.5996 157.898 47.1996C157.898 45.7996 159.098 44.5996 160.498 44.5996C161.998 44.5996 163.098 45.7996 163.098 47.1996Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0984 62.3998C39.0984 63.7998 37.8984 64.9998 36.4984 64.9998C35.0984 64.9998 33.8984 63.7998 33.8984 62.3998C33.8984 60.9998 35.0984 59.7998 36.4984 59.7998C37.8984 59.7998 39.0984 60.9998 39.0984 62.3998Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7 106.1C124.7 107.5 123.5 108.7 122.1 108.7C120.7 108.7 119.5 107.5 119.5 106.1C119.5 104.7 120.7 103.5 122.1 103.5C123.5 103.5 124.7 104.7 124.7 106.1Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2996 88.3002C59.2996 89.7002 58.0996 90.9002 56.6996 90.9002C55.2996 90.9002 54.0996 89.7002 54.0996 88.3002C54.0996 86.9002 55.2996 85.7002 56.6996 85.7002C58.1996 85.7002 59.2996 86.8002 59.2996 88.3002Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.499 69.5H174.799",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.298 60.3999H175.998",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 65H4",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5996 42H49.5996",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1 102.9H96.0996",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1310.9 174H1303.1V196.2H1310.9V174Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326 168H1318.2V196.3H1326V168Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.1 161.6H1333.3V196.3H1341.1V161.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.2 151.8H1348.4V196.3H1356.2V151.8Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355.8 130C1343.3 144.8 1331.5 158.1 1303.1 158.1",
    stroke: "#192657",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.7 130H1355.8V139",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1309.6 203.5C1309.6 204.9 1308.4 206.1 1307 206.1C1305.6 206.1 1304.4 204.9 1304.4 203.5C1304.4 202.1 1305.6 200.9 1307 200.9C1308.4 200.9 1309.6 202 1309.6 203.5Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1305.7 134.5C1305.7 135.9 1304.5 137.1 1303.1 137.1C1301.7 137.1 1300.5 135.9 1300.5 134.5C1300.5 133.1 1301.7 131.9 1303.1 131.9C1304.6 131.9 1305.7 133.1 1305.7 134.5Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1292.3 150C1292.3 151.4 1291.1 152.6 1289.7 152.6C1288.3 152.6 1287.1 151.4 1287.1 150C1287.1 148.6 1288.3 147.4 1289.7 147.4C1291.2 147.4 1292.3 148.6 1292.3 150Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1384.7 206.1C1384.7 207.5 1383.5 208.7 1382.1 208.7C1380.7 208.7 1379.5 207.5 1379.5 206.1C1379.5 204.7 1380.7 203.5 1382.1 203.5C1383.6 203.5 1384.7 204.6 1384.7 206.1Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1274 168.3H1265",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1287.6 187.4H1278.6",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1244.1 549.3C1244.1 550.7 1242.9 551.9 1241.5 551.9C1240.1 551.9 1238.9 550.7 1238.9 549.3C1238.9 547.9 1240.1 546.7 1241.5 546.7C1242.9 546.7 1244.1 547.9 1244.1 549.3Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.2 446.6C1275.2 455.9 1267.6 463.5 1258.3 463.5C1249 463.5 1241.4 455.9 1241.4 446.6C1241.4 440.6 1244.5 432.4 1249.1 427.2C1249.4 427.3 1249.7 427.3 1250 427.3H1266.6C1266.9 427.3 1267.2 427.3 1267.5 427.2C1272.2 432.4 1275.2 440.7 1275.2 446.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.6 421.5L1269.4 412.8C1269.8 411 1268.3 409.4 1266.7 410L1260.8 411.9C1259.3 412.4 1257.6 412.4 1256.1 411.9L1250 410C1248.4 409.5 1246.9 411.1 1247.3 412.8L1249.1 421.6",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.6 421.5L1269.4 412.8C1269.8 411 1268.3 409.4 1266.7 410L1260.8 411.9C1259.3 412.4 1257.6 412.4 1256.1 411.9L1250 410C1248.4 409.5 1246.9 411.1 1247.3 412.8L1249.1 421.6",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.6 424.4C1269.6 425.2 1269.3 425.9 1268.7 426.4C1268.4 426.7 1267.9 427 1267.5 427.1C1267.2 427.2 1266.9 427.2 1266.6 427.2H1250C1249.7 427.2 1249.4 427.1 1249.1 427.1C1247.9 426.7 1247 425.6 1247 424.3C1247 423.5 1247.3 422.8 1247.9 422.2C1248.4 421.7 1249.2 421.3 1250 421.3H1266.6C1268.3 421.5 1269.6 422.8 1269.6 424.4Z",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.74 447.582C1261.74 446.982 1261.53 446.478 1261.11 446.067C1260.69 445.657 1259.98 445.285 1258.99 444.953C1257.6 444.529 1256.59 443.979 1255.95 443.301C1255.32 442.617 1255 441.751 1255 440.702C1255 439.633 1255.31 438.757 1255.93 438.073C1256.55 437.389 1257.41 436.982 1258.5 436.851V434.711H1259.95V436.861C1261.05 437.011 1261.9 437.47 1262.5 438.239C1263.12 439.008 1263.42 440.06 1263.42 441.396H1261.63C1261.63 440.477 1261.41 439.747 1260.97 439.207C1260.53 438.666 1259.94 438.395 1259.2 438.395C1258.43 438.395 1257.83 438.597 1257.42 439.001C1257.01 439.399 1256.81 439.956 1256.81 440.673C1256.81 441.337 1257.02 441.868 1257.45 442.265C1257.89 442.656 1258.6 443.015 1259.59 443.34C1260.59 443.66 1261.36 444.015 1261.92 444.406C1262.48 444.79 1262.89 445.24 1263.15 445.754C1263.42 446.269 1263.55 446.872 1263.55 447.562C1263.55 448.663 1263.22 449.549 1262.55 450.22C1261.9 450.892 1260.97 451.289 1259.78 451.413V453.279H1258.33V451.413C1257.12 451.302 1256.17 450.872 1255.48 450.123C1254.79 449.367 1254.45 448.344 1254.45 447.054H1256.26C1256.26 447.96 1256.5 448.657 1256.97 449.145C1257.45 449.634 1258.12 449.878 1259 449.878C1259.85 449.878 1260.52 449.673 1261.01 449.263C1261.5 448.852 1261.74 448.292 1261.74 447.582Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.11 446.067L1260.84 446.334L1260.85 446.336L1261.11 446.067ZM1258.99 444.953L1259.11 444.597L1259.1 444.594L1258.99 444.953ZM1255.95 443.301L1255.67 443.556L1255.67 443.559L1255.95 443.301ZM1255.93 438.073L1255.65 437.82L1255.65 437.821L1255.93 438.073ZM1258.5 436.851L1258.54 437.224L1258.87 437.184V436.851H1258.5ZM1258.5 434.711V434.336H1258.12V434.711H1258.5ZM1259.95 434.711H1260.33V434.336H1259.95V434.711ZM1259.95 436.861H1259.58V437.188L1259.9 437.233L1259.95 436.861ZM1262.5 438.239L1262.21 438.471L1262.21 438.473L1262.5 438.239ZM1263.42 441.396V441.771H1263.8V441.396H1263.42ZM1261.63 441.396H1261.25V441.771H1261.63V441.396ZM1257.42 439.001L1257.68 439.271L1257.69 439.269L1257.42 439.001ZM1257.45 442.265L1257.2 442.541L1257.2 442.545L1257.45 442.265ZM1259.59 443.34L1259.48 443.697L1259.48 443.698L1259.59 443.34ZM1261.92 444.406L1261.7 444.712L1261.71 444.715L1261.92 444.406ZM1263.15 445.754L1262.82 445.924L1262.82 445.927L1263.15 445.754ZM1262.55 450.22L1262.29 449.957L1262.29 449.958L1262.55 450.22ZM1259.78 451.413L1259.74 451.04L1259.4 451.075V451.413H1259.78ZM1259.78 453.279V453.654H1260.15V453.279H1259.78ZM1258.33 453.279H1257.96V453.654H1258.33V453.279ZM1258.33 451.413H1258.71V451.07L1258.37 451.039L1258.33 451.413ZM1255.48 450.123L1255.2 450.374L1255.2 450.377L1255.48 450.123ZM1254.45 447.054V446.679H1254.08V447.054H1254.45ZM1256.26 447.054H1256.63V446.679H1256.26V447.054ZM1262.12 447.582C1262.12 446.883 1261.87 446.28 1261.37 445.798L1260.85 446.336C1261.2 446.675 1261.37 447.082 1261.37 447.582H1262.12ZM1261.37 445.8C1260.89 445.329 1260.12 444.935 1259.11 444.597L1258.87 445.309C1259.85 445.635 1260.49 445.984 1260.84 446.334L1261.37 445.8ZM1259.1 444.594C1257.74 444.18 1256.8 443.655 1256.22 443.044L1255.67 443.559C1256.38 444.303 1257.46 444.879 1258.88 445.312L1259.1 444.594ZM1256.22 443.047C1255.66 442.441 1255.37 441.669 1255.37 440.702H1254.62C1254.62 441.832 1254.97 442.794 1255.67 443.556L1256.22 443.047ZM1255.37 440.702C1255.37 439.711 1255.66 438.929 1256.21 438.325L1255.65 437.821C1254.96 438.585 1254.62 439.556 1254.62 440.702H1255.37ZM1256.2 438.326C1256.76 437.72 1257.53 437.345 1258.54 437.224L1258.45 436.479C1257.29 436.618 1256.35 437.058 1255.65 437.82L1256.2 438.326ZM1258.87 436.851V434.711H1258.12V436.851H1258.87ZM1258.5 435.086H1259.95V434.336H1258.5V435.086ZM1259.58 434.711V436.861H1260.33V434.711H1259.58ZM1259.9 437.233C1260.91 437.371 1261.67 437.789 1262.21 438.471L1262.8 438.007C1262.13 437.152 1261.18 436.651 1260 436.49L1259.9 437.233ZM1262.21 438.473C1262.75 439.155 1263.05 440.115 1263.05 441.396H1263.8C1263.8 440.005 1263.48 438.861 1262.8 438.005L1262.21 438.473ZM1263.42 441.021H1261.63V441.771H1263.42V441.021ZM1262 441.396C1262 440.419 1261.77 439.597 1261.26 438.971L1260.68 439.442C1261.05 439.897 1261.25 440.535 1261.25 441.396H1262ZM1261.26 438.971C1260.75 438.335 1260.05 438.02 1259.2 438.02V438.77C1259.84 438.77 1260.32 438.996 1260.68 439.442L1261.26 438.971ZM1259.2 438.02C1258.36 438.02 1257.66 438.24 1257.16 438.734L1257.69 439.269C1258 438.955 1258.49 438.77 1259.2 438.77V438.02ZM1257.16 438.732C1256.66 439.217 1256.43 439.882 1256.43 440.673H1257.18C1257.18 440.03 1257.36 439.581 1257.68 439.271L1257.16 438.732ZM1256.43 440.673C1256.43 441.426 1256.68 442.063 1257.2 442.541L1257.71 441.99C1257.36 441.674 1257.18 441.248 1257.18 440.673H1256.43ZM1257.2 442.545C1257.7 442.987 1258.47 443.365 1259.48 443.697L1259.71 442.984C1258.74 442.664 1258.08 442.325 1257.7 441.986L1257.2 442.545ZM1259.48 443.698C1260.46 444.011 1261.19 444.352 1261.7 444.712L1262.13 444.099C1261.54 443.678 1260.72 443.309 1259.71 442.983L1259.48 443.698ZM1261.71 444.715C1262.22 445.07 1262.59 445.474 1262.82 445.924L1263.48 445.585C1263.19 445.005 1262.73 444.51 1262.13 444.096L1261.71 444.715ZM1262.82 445.927C1263.05 446.379 1263.18 446.92 1263.18 447.562H1263.93C1263.93 446.823 1263.78 446.159 1263.48 445.582L1262.82 445.927ZM1263.18 447.562C1263.18 448.582 1262.87 449.367 1262.29 449.957L1262.82 450.484C1263.57 449.731 1263.93 448.744 1263.93 447.562H1263.18ZM1262.29 449.958C1261.7 450.551 1260.87 450.922 1259.74 451.04L1259.82 451.786C1261.07 451.655 1262.09 451.232 1262.82 450.483L1262.29 449.958ZM1259.4 451.413V453.279H1260.15V451.413H1259.4ZM1259.78 452.904H1258.33V453.654H1259.78V452.904ZM1258.71 453.279V451.413H1257.96V453.279H1258.71ZM1258.37 451.039C1257.23 450.935 1256.37 450.537 1255.75 449.869L1255.2 450.377C1255.97 451.207 1257.01 451.669 1258.3 451.786L1258.37 451.039ZM1255.76 449.871C1255.15 449.201 1254.83 448.277 1254.83 447.054H1254.08C1254.08 448.412 1254.44 449.533 1255.2 450.374L1255.76 449.871ZM1254.45 447.429H1256.26V446.679H1254.45V447.429ZM1255.88 447.054C1255.88 448.024 1256.14 448.828 1256.7 449.407L1257.24 448.884C1256.85 448.486 1256.63 447.895 1256.63 447.054H1255.88ZM1256.7 449.407C1257.27 449.987 1258.05 450.253 1259 450.253V449.503C1258.19 449.503 1257.63 449.281 1257.24 448.884L1256.7 449.407ZM1259 450.253C1259.91 450.253 1260.67 450.034 1261.25 449.55L1260.77 448.976C1260.37 449.313 1259.79 449.503 1259 449.503V450.253ZM1261.25 449.55C1261.83 449.06 1262.12 448.389 1262.12 447.582H1261.37C1261.37 448.195 1261.16 448.645 1260.77 448.976L1261.25 449.55Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8 468.728C166.8 478.028 159.2 485.628 149.9 485.628C140.6 485.628 133 478.028 133 468.728C133 462.728 136.1 454.528 140.7 449.328C141 449.428 141.3 449.428 141.6 449.428H158.2C158.5 449.428 158.8 449.428 159.1 449.328C163.8 454.528 166.8 462.828 166.8 468.728Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.199 443.628L160.999 434.928C161.399 433.128 159.899 431.528 158.299 432.128L152.399 434.028C150.899 434.528 149.199 434.528 147.699 434.028L141.599 432.128C139.999 431.628 138.499 433.228 138.899 434.928L140.699 443.728",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.199 443.628L160.999 434.928C161.399 433.128 159.899 431.528 158.299 432.128L152.399 434.028C150.899 434.528 149.199 434.528 147.699 434.028L141.599 432.128C139.999 431.628 138.499 433.228 138.899 434.928L140.699 443.728",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.2 446.528C161.2 447.328 160.9 448.028 160.3 448.528C160 448.828 159.5 449.128 159.1 449.228C158.8 449.328 158.5 449.328 158.2 449.328H141.6C141.3 449.328 141 449.228 140.7 449.228C139.5 448.828 138.6 447.728 138.6 446.428C138.6 445.628 138.9 444.928 139.5 444.328C140 443.828 140.8 443.428 141.6 443.428H158.2C159.9 443.628 161.2 444.928 161.2 446.528Z",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.342 469.71C153.342 469.11 153.13 468.605 152.707 468.195C152.29 467.785 151.583 467.413 150.586 467.081C149.198 466.657 148.185 466.107 147.547 465.429C146.915 464.745 146.599 463.879 146.599 462.83C146.599 461.761 146.908 460.885 147.527 460.201C148.153 459.517 149.009 459.11 150.097 458.979V456.839H151.554V458.989C152.648 459.139 153.498 459.598 154.104 460.367C154.717 461.136 155.023 462.188 155.023 463.524H153.225C153.225 462.605 153.006 461.875 152.57 461.335C152.133 460.794 151.544 460.523 150.801 460.523C150.026 460.523 149.433 460.725 149.022 461.129C148.612 461.527 148.407 462.084 148.407 462.8C148.407 463.465 148.622 463.996 149.052 464.393C149.488 464.784 150.202 465.143 151.192 465.468C152.189 465.788 152.964 466.143 153.518 466.534C154.078 466.918 154.489 467.368 154.749 467.882C155.016 468.397 155.15 469 155.15 469.69C155.15 470.791 154.818 471.677 154.153 472.348C153.495 473.019 152.57 473.417 151.378 473.541V475.407H149.931V473.541C148.72 473.43 147.768 473 147.078 472.251C146.394 471.495 146.052 470.472 146.052 469.182H147.86C147.86 470.088 148.097 470.785 148.573 471.273C149.049 471.762 149.723 472.006 150.596 472.006C151.449 472.006 152.12 471.801 152.609 471.391C153.098 470.98 153.342 470.42 153.342 469.71Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.707 468.195L152.444 468.462L152.446 468.464L152.707 468.195ZM150.586 467.081L150.705 466.725L150.696 466.722L150.586 467.081ZM147.547 465.429L147.271 465.684L147.274 465.686L147.547 465.429ZM147.527 460.201L147.25 459.948L147.249 459.949L147.527 460.201ZM150.097 458.979L150.142 459.352L150.472 459.312V458.979H150.097ZM150.097 456.839V456.464H149.722V456.839H150.097ZM151.554 456.839H151.929V456.464H151.554V456.839ZM151.554 458.989H151.179V459.316L151.503 459.361L151.554 458.989ZM154.104 460.367L153.81 460.599L153.811 460.601L154.104 460.367ZM155.023 463.524V463.899H155.398V463.524H155.023ZM153.225 463.524H152.85V463.899H153.225V463.524ZM149.022 461.129L149.283 461.399L149.285 461.397L149.022 461.129ZM149.052 464.393L148.797 464.669L148.802 464.673L149.052 464.393ZM151.192 465.468L151.075 465.825L151.078 465.826L151.192 465.468ZM153.518 466.534L153.302 466.84L153.306 466.843L153.518 466.534ZM154.749 467.882L154.415 468.052L154.416 468.055L154.749 467.882ZM154.153 472.348L153.887 472.085L153.885 472.086L154.153 472.348ZM151.378 473.541L151.339 473.168L151.003 473.203V473.541H151.378ZM151.378 475.407V475.782H151.753V475.407H151.378ZM149.931 475.407H149.556V475.782H149.931V475.407ZM149.931 473.541H150.306V473.198L149.965 473.167L149.931 473.541ZM147.078 472.251L146.8 472.502L146.802 472.505L147.078 472.251ZM146.052 469.182V468.807H145.677V469.182H146.052ZM147.86 469.182H148.235V468.807H147.86V469.182ZM153.717 469.71C153.717 469.011 153.465 468.408 152.968 467.926L152.446 468.464C152.795 468.803 152.967 469.21 152.967 469.71H153.717ZM152.97 467.928C152.491 467.457 151.719 467.063 150.705 466.725L150.468 467.437C151.447 467.763 152.088 468.112 152.444 468.462L152.97 467.928ZM150.696 466.722C149.338 466.308 148.395 465.783 147.82 465.172L147.274 465.686C147.975 466.431 149.058 467.007 150.477 467.44L150.696 466.722ZM147.822 465.175C147.262 464.569 146.974 463.797 146.974 462.83H146.224C146.224 463.96 146.567 464.922 147.271 465.684L147.822 465.175ZM146.974 462.83C146.974 461.839 147.259 461.057 147.805 460.452L147.249 459.949C146.558 460.713 146.224 461.684 146.224 462.83H146.974ZM147.804 460.454C148.358 459.848 149.126 459.473 150.142 459.352L150.053 458.607C148.893 458.746 147.947 459.186 147.25 459.948L147.804 460.454ZM150.472 458.979V456.839H149.722V458.979H150.472ZM150.097 457.214H151.554V456.464H150.097V457.214ZM151.179 456.839V458.989H151.929V456.839H151.179ZM151.503 459.361C152.514 459.499 153.272 459.917 153.81 460.599L154.399 460.135C153.725 459.28 152.782 458.779 151.604 458.618L151.503 459.361ZM153.811 460.601C154.354 461.283 154.648 462.243 154.648 463.524H155.398C155.398 462.133 155.079 460.989 154.398 460.133L153.811 460.601ZM155.023 463.149H153.225V463.899H155.023V463.149ZM153.6 463.524C153.6 462.547 153.367 461.725 152.862 461.099L152.278 461.57C152.646 462.025 152.85 462.663 152.85 463.524H153.6ZM152.862 461.099C152.349 460.463 151.648 460.148 150.801 460.148V460.898C151.439 460.898 151.918 461.124 152.278 461.57L152.862 461.099ZM150.801 460.148C149.962 460.148 149.262 460.368 148.759 460.862L149.285 461.397C149.604 461.083 150.089 460.898 150.801 460.898V460.148ZM148.762 460.86C148.261 461.345 148.032 462.01 148.032 462.8H148.782C148.782 462.158 148.963 461.708 149.283 461.399L148.762 460.86ZM148.032 462.8C148.032 463.554 148.28 464.19 148.797 464.669L149.306 464.118C148.964 463.801 148.782 463.376 148.782 462.8H148.032ZM148.802 464.673C149.296 465.115 150.068 465.493 151.075 465.825L151.309 465.112C150.336 464.792 149.681 464.453 149.302 464.114L148.802 464.673ZM151.078 465.826C152.056 466.139 152.791 466.48 153.302 466.84L153.734 466.227C153.137 465.806 152.322 465.437 151.306 465.111L151.078 465.826ZM153.306 466.843C153.823 467.198 154.187 467.602 154.415 468.052L155.084 467.713C154.79 467.133 154.333 466.638 153.73 466.224L153.306 466.843ZM154.416 468.055C154.651 468.507 154.775 469.048 154.775 469.69H155.525C155.525 468.951 155.382 468.287 155.082 467.71L154.416 468.055ZM154.775 469.69C154.775 470.71 154.47 471.495 153.887 472.085L154.42 472.612C155.165 471.859 155.525 470.872 155.525 469.69H154.775ZM153.885 472.086C153.304 472.679 152.469 473.05 151.339 473.168L151.416 473.914C152.671 473.783 153.686 473.36 154.421 472.611L153.885 472.086ZM151.003 473.541V475.407H151.753V473.541H151.003ZM151.378 475.032H149.931V475.782H151.378V475.032ZM150.306 475.407V473.541H149.556V475.407H150.306ZM149.965 473.167C148.827 473.063 147.969 472.665 147.353 471.996L146.802 472.505C147.567 473.335 148.612 473.797 149.897 473.914L149.965 473.167ZM147.356 471.999C146.749 471.329 146.427 470.405 146.427 469.182H145.677C145.677 470.539 146.038 471.661 146.8 472.502L147.356 471.999ZM146.052 469.557H147.86V468.807H146.052V469.557ZM147.485 469.182C147.485 470.152 147.74 470.956 148.304 471.535L148.842 471.012C148.454 470.614 148.235 470.023 148.235 469.182H147.485ZM148.304 471.535C148.869 472.115 149.651 472.381 150.596 472.381V471.631C149.794 471.631 149.228 471.409 148.842 471.012L148.304 471.535ZM150.596 472.381C151.508 472.381 152.274 472.162 152.85 471.678L152.368 471.104C151.967 471.441 151.391 471.631 150.596 471.631V472.381ZM152.85 471.678C153.434 471.187 153.717 470.517 153.717 469.71H152.967C152.967 470.323 152.761 470.773 152.368 471.104L152.85 471.678Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.1 508.6V519.2C1268.1 524.2 1264 528.3 1259 528.3L1259.7 538.2L1246.1 528.3H1235.4V521.8C1235.4 518.6 1234 515.7 1231.7 513.7C1229.8 512.1 1227.4 511.1 1224.7 511.1H1219.5V508.7C1219.5 503.7 1223.6 499.6 1228.6 499.6H1259.1C1264 499.5 1268.1 503.6 1268.1 508.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.6 507.4H1229.2",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.7 519.9H1242.3",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.7 513.601H1247.5",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.8 513.601H1231.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.4 521.7V534.2C1235.4 540.1 1230.6 544.9 1224.7 544.9H1204L1187.9 556.6L1188.7 544.9C1182.8 544.9 1178 540.1 1178 534.2V521.7C1178 515.8 1182.8 511.001 1188.7 511.001H1224.7C1227.4 511.001 1229.8 512 1231.7 513.6C1233.9 515.6 1235.4 518.5 1235.4 521.7Z",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.1 520.3H1223.8",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.8 535.101H1208.4",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.8 527.701H1202.3",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.7 527.701H1222.9",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.1 372.3H1312.1C1310.1 372.3 1308.5 370.7 1308.5 368.7V334.7C1308.5 332.7 1310.1 331.1 1312.1 331.1H1373.1C1375.1 331.1 1376.7 332.7 1376.7 334.7V368.7C1376.7 370.7 1375.1 372.3 1373.1 372.3Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.9 364H1333.5",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.7 364H1354.8",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.1 364H1369.6",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.7 340.2H1317.5V352.4H1329.7V340.2Z",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.6 340.2V345",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.2 346.3V351.1",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.6 331.1V372.3",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.3 504.3C1341.4 504.3 1343.1 502.599 1343.1 500.5C1343.1 498.402 1341.4 496.7 1339.3 496.7C1337.2 496.7 1335.5 498.402 1335.5 500.5C1335.5 502.599 1337.2 504.3 1339.3 504.3Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.4 498.6C1371.4 500.4 1370 501.8 1368.2 501.8C1366.4 501.8 1365 500.4 1365 498.6C1365 496.8 1366.4 495.4 1368.2 495.4C1370 495.4 1371.4 496.8 1371.4 498.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.1 478.9H1338.6L1333.9 459.2H1373.9L1369.1 478.9Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.7 500L1344.3 495.4H1369.9C1372.1 495.4 1373.8 493.6 1373.8 491.5C1373.8 489.3 1372 487.6 1369.9 487.6H1340.5L1330.5 445.5H1320.8",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.6 465.5H1361.1",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337 472.1H1353.9",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.3 368.7C1281.3 370.1 1280.1 371.3 1278.7 371.3C1277.3 371.3 1276.1 370.1 1276.1 368.7C1276.1 367.3 1277.3 366.1 1278.7 366.1C1280.1 366.1 1281.3 367.3 1281.3 368.7Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.8 542.8C1317.8 544.2 1316.6 545.4 1315.2 545.4C1313.8 545.4 1312.6 544.2 1312.6 542.8C1312.6 541.4 1313.8 540.2 1315.2 540.2C1316.7 540.2 1317.8 541.4 1317.8 542.8Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.3 424C1298.3 425.4 1297.1 426.6 1295.7 426.6C1294.3 426.6 1293.1 425.4 1293.1 424C1293.1 422.6 1294.3 421.4 1295.7 421.4C1297.1 421.4 1298.3 422.5 1298.3 424Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2 424C85.2 425.4 84 426.6 82.6 426.6C81.2 426.6 80 425.4 80 424C80 422.6 81.2 421.4 82.6 421.4C84 421.4 85.2 422.5 85.2 424Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.8 531.6H1319.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.7 494.1H1310.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1378.6 182.1H1369.6",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0984 515.6H28.2984C26.1984 515.6 24.3984 513.9 24.3984 511.7V471.9C24.3984 469.8 26.0984 468 28.2984 468H78.0984C80.1984 468 81.9984 469.7 81.9984 471.9V511.8C81.9984 513.9 80.2984 515.6 78.0984 515.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3984 503H81.9984",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4984 509.6C55.4984 510.9 54.4984 511.9 53.1984 511.9C51.8984 511.9 50.8984 510.9 50.8984 509.6C50.8984 508.3 51.8984 507.3 53.1984 507.3C54.4984 507.3 55.4984 508.4 55.4984 509.6Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0988 515.6H46.2988V523.1H60.0988V515.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3988 529.3H40.0988C38.7988 529.3 37.7988 528.3 37.7988 527V525.5C37.7988 524.2 38.7988 523.2 40.0988 523.2H66.3988C67.6988 523.2 68.6988 524.3 68.6988 525.5V527C68.6988 528.3 67.6988 529.3 66.3988 529.3Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.2 512.6C9.2 514 8 515.2 6.6 515.2C5.2 515.2 4 514 4 512.6C4 511.2 5.2 510 6.6 510C8.1 510.1 9.2 511.2 9.2 512.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 545.5H121.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.199 536.4H120.499",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4277 221.901C44.511 221.901 55.9277 210.484 55.9277 196.401C55.9277 182.318 44.511 170.901 30.4277 170.901C16.3445 170.901 4.92773 182.318 4.92773 196.401C4.92773 210.484 16.3445 221.901 30.4277 221.901Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1863 209.083C51.1782 201.482 50.6842 189.652 43.083 182.66C35.4818 175.668 23.6518 176.162 16.6599 183.763C9.66802 191.364 10.162 203.194 17.7632 210.186C25.3644 217.178 37.1944 216.684 44.1863 209.083Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4277 170.901V177.701",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.327 183.301L46.627 186.901",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1277 187.201L8.42773 183.501",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7285 179.101L16.5285 183.901",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9385 190.674C24.9385 189.905 25.1822 189.271 25.6695 188.772C26.1628 188.273 26.794 188.023 27.5632 188.023C28.3441 188.023 28.9754 188.276 29.4568 188.781C29.9442 189.28 30.1879 189.929 30.1879 190.727V191.353C30.1879 192.128 29.9413 192.762 29.448 193.255C28.9607 193.742 28.3383 193.986 27.5808 193.986C26.8175 193.986 26.1862 193.742 25.6871 193.255C25.188 192.762 24.9385 192.107 24.9385 191.291V190.674ZM26.1539 191.353C26.1539 191.811 26.2831 192.189 26.5415 192.489C26.7998 192.782 27.1463 192.929 27.5808 192.929C27.9977 192.929 28.3324 192.785 28.5849 192.498C28.8432 192.21 28.9724 191.816 28.9724 191.317V190.674C28.9724 190.216 28.8462 189.838 28.5937 189.538C28.3412 189.239 27.9977 189.089 27.5632 189.089C27.1287 189.089 26.7852 189.239 26.5327 189.538C26.2802 189.838 26.1539 190.228 26.1539 190.71V191.353ZM31.1832 197.888C31.1832 197.119 31.4268 196.487 31.9142 195.994C32.4074 195.495 33.0386 195.246 33.8079 195.246C34.5771 195.246 35.2083 195.492 35.7015 195.985C36.1947 196.479 36.4414 197.133 36.4414 197.95V198.575C36.4414 199.344 36.1947 199.978 35.7015 200.477C35.2141 200.971 34.5888 201.217 33.8255 201.217C33.0621 201.217 32.4309 200.974 31.9318 200.486C31.4327 199.993 31.1832 199.338 31.1832 198.522V197.888ZM32.3986 198.575C32.3986 199.039 32.5278 199.42 32.7862 199.72C33.0445 200.013 33.391 200.16 33.8255 200.16C34.2482 200.16 34.5859 200.016 34.8384 199.729C35.0908 199.435 35.2171 199.039 35.2171 198.54V197.888C35.2171 197.424 35.0879 197.045 34.8295 196.752C34.5771 196.458 34.2365 196.311 33.8079 196.311C33.391 196.311 33.0504 196.458 32.7862 196.752C32.5278 197.039 32.3986 197.43 32.3986 197.923V198.575ZM27.9507 200.063L27.0259 199.482L33.2882 189.459L34.213 190.04L27.9507 200.063Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6695 188.772L25.4028 188.508L25.4012 188.51L25.6695 188.772ZM29.4568 188.781L29.1854 189.039L29.1885 189.043L29.4568 188.781ZM25.6871 193.255L25.4235 193.522L25.4251 193.523L25.6871 193.255ZM26.5415 192.489L26.2575 192.734L26.26 192.736L26.5415 192.489ZM28.5849 192.498L28.3058 192.247L28.303 192.25L28.5849 192.498ZM31.9142 195.994L31.6475 195.731L31.6474 195.731L31.9142 195.994ZM35.7015 200.477L35.4348 200.214L35.4348 200.214L35.7015 200.477ZM31.9318 200.486L31.6682 200.753L31.6698 200.754L31.9318 200.486ZM32.7862 199.72L32.5022 199.965L32.5046 199.968L32.7862 199.72ZM34.8384 199.729L35.1202 199.976L35.1227 199.973L34.8384 199.729ZM34.8295 196.752L34.5452 196.996L34.548 196.999L34.8295 196.752ZM32.7862 196.752L32.5074 196.501L32.5071 196.501L32.7862 196.752ZM27.9507 200.063L27.7512 200.381L28.0695 200.581L28.2688 200.262L27.9507 200.063ZM27.0259 199.482L26.7079 199.283L26.5097 199.601L26.8263 199.8L27.0259 199.482ZM33.2882 189.459L33.4878 189.141L33.1694 188.941L32.9702 189.26L33.2882 189.459ZM34.213 190.04L34.531 190.239L34.7292 189.922L34.4126 189.723L34.213 190.04ZM25.3135 190.674C25.3135 189.992 25.5262 189.455 25.9378 189.034L25.4012 188.51C24.8381 189.087 24.5635 189.818 24.5635 190.674H25.3135ZM25.9363 189.035C26.3519 188.615 26.8836 188.398 27.5632 188.398V187.648C26.7044 187.648 25.9736 187.931 25.4028 188.508L25.9363 189.035ZM27.5632 188.398C28.2551 188.398 28.7835 188.618 29.1854 189.039L29.7282 188.522C29.1672 187.934 28.4332 187.648 27.5632 187.648V188.398ZM29.1885 189.043C29.5975 189.461 29.8129 190.011 29.8129 190.727H30.5629C30.5629 189.846 30.2909 189.098 29.7251 188.519L29.1885 189.043ZM29.8129 190.727V191.353H30.5629V190.727H29.8129ZM29.8129 191.353C29.8129 192.04 29.5976 192.575 29.1829 192.99L29.7132 193.52C30.2849 192.948 30.5629 192.215 30.5629 191.353H29.8129ZM29.1829 192.99C28.7731 193.4 28.2496 193.611 27.5808 193.611V194.361C28.4269 194.361 29.1482 194.085 29.7132 193.52L29.1829 192.99ZM27.5808 193.611C26.9053 193.611 26.3713 193.399 25.9491 192.987L25.4251 193.523C26.0012 194.086 26.7297 194.361 27.5808 194.361V193.611ZM25.9507 192.988C25.5346 192.577 25.3135 192.025 25.3135 191.291H24.5635C24.5635 192.19 24.8415 192.947 25.4235 193.522L25.9507 192.988ZM25.3135 191.291V190.674H24.5635V191.291H25.3135ZM25.7789 191.353C25.7789 191.885 25.9313 192.356 26.2576 192.734L26.8254 192.244C26.6349 192.023 26.5289 191.736 26.5289 191.353H25.7789ZM26.26 192.736C26.5979 193.121 27.0519 193.304 27.5808 193.304V192.554C27.2407 192.554 27.0018 192.444 26.823 192.241L26.26 192.736ZM27.5808 193.304C28.0948 193.304 28.5362 193.122 28.8667 192.745L28.303 192.25C28.1286 192.449 27.9006 192.554 27.5808 192.554V193.304ZM28.8639 192.748C29.2003 192.373 29.3474 191.881 29.3474 191.317H28.5974C28.5974 191.752 28.4861 192.046 28.3059 192.247L28.8639 192.748ZM29.3474 191.317V190.674H28.5974V191.317H29.3474ZM29.3474 190.674C29.3474 190.144 29.1993 189.675 28.8804 189.296L28.307 189.78C28.4931 190.001 28.5974 190.289 28.5974 190.674H29.3474ZM28.8804 189.296C28.5483 188.903 28.0946 188.714 27.5632 188.714V189.464C27.9008 189.464 28.1341 189.575 28.307 189.78L28.8804 189.296ZM27.5632 188.714C27.0318 188.714 26.5781 188.903 26.246 189.296L26.8194 189.78C26.9923 189.575 27.2256 189.464 27.5632 189.464V188.714ZM26.246 189.296C25.9242 189.678 25.7789 190.161 25.7789 190.71H26.5289C26.5289 190.296 26.6361 189.997 26.8194 189.78L26.246 189.296ZM25.7789 190.71V191.353H26.5289V190.71H25.7789ZM31.5582 197.888C31.5582 197.206 31.7708 196.673 32.1809 196.258L31.6474 195.731C31.0829 196.302 30.8082 197.032 30.8082 197.888H31.5582ZM32.1809 196.258C32.5966 195.837 33.1282 195.621 33.8079 195.621V194.871C32.949 194.871 32.2183 195.153 31.6475 195.731L32.1809 196.258ZM33.8079 195.621C34.4888 195.621 35.021 195.835 35.4363 196.251L35.9667 195.72C35.3956 195.149 34.6653 194.871 33.8079 194.871V195.621ZM35.4363 196.251C35.8473 196.662 36.0664 197.215 36.0664 197.95H36.8164C36.8164 197.052 36.5422 196.296 35.9667 195.72L35.4363 196.251ZM36.0664 197.95V198.575H36.8164V197.95H36.0664ZM36.0664 198.575C36.0664 199.256 35.8516 199.792 35.4348 200.214L35.9682 200.741C36.5378 200.165 36.8164 199.432 36.8164 198.575H36.0664ZM35.4348 200.214C35.0253 200.628 34.4997 200.842 33.8255 200.842V201.592C34.6779 201.592 35.403 201.313 35.9683 200.741L35.4348 200.214ZM33.8255 200.842C33.1499 200.842 32.6159 200.63 32.1938 200.218L31.6698 200.754C32.2459 201.317 32.9743 201.592 33.8255 201.592V200.842ZM32.1954 200.219C31.7793 199.808 31.5582 199.256 31.5582 198.522H30.8082C30.8082 199.421 31.0861 200.178 31.6682 200.753L32.1954 200.219ZM31.5582 198.522V197.888H30.8082V198.522H31.5582ZM32.0236 198.575C32.0236 199.112 32.1752 199.586 32.5022 199.965L33.0701 199.475C32.8804 199.255 32.7736 198.965 32.7736 198.575H32.0236ZM32.5046 199.968C32.8426 200.352 33.2966 200.535 33.8255 200.535V199.785C33.4853 199.785 33.2464 199.675 33.0677 199.472L32.5046 199.968ZM33.8255 200.535C34.3435 200.535 34.7886 200.354 35.1202 199.976L34.5565 199.481C34.3831 199.679 34.1529 199.785 33.8255 199.785V200.535ZM35.1227 199.973C35.4489 199.594 35.5921 199.102 35.5921 198.54H34.8421C34.8421 198.976 34.7328 199.276 34.554 199.484L35.1227 199.973ZM35.5921 198.54V197.888H34.8421V198.54H35.5921ZM35.5921 197.888C35.5921 197.351 35.4405 196.878 35.1111 196.504L34.548 196.999C34.7353 197.212 34.8421 197.497 34.8421 197.888H35.5921ZM35.1139 196.507C34.782 196.121 34.3326 195.936 33.8079 195.936V196.686C34.1404 196.686 34.3721 196.795 34.5452 196.996L35.1139 196.507ZM33.8079 195.936C33.2913 195.936 32.8471 196.123 32.5074 196.501L33.0649 197.003C33.2537 196.793 33.4906 196.686 33.8079 196.686V195.936ZM32.5071 196.501C32.1714 196.875 32.0236 197.364 32.0236 197.923H32.7736C32.7736 197.496 32.8842 197.204 33.0652 197.002L32.5071 196.501ZM32.0236 197.923V198.575H32.7736V197.923H32.0236ZM28.1503 199.746L27.2255 199.165L26.8263 199.8L27.7512 200.381L28.1503 199.746ZM27.3439 199.681L33.6062 189.658L32.9702 189.26L26.7079 199.283L27.3439 199.681ZM33.0886 189.776L34.0134 190.358L34.4126 189.723L33.4878 189.141L33.0886 189.776ZM33.895 189.841L27.6327 199.865L28.2688 200.262L34.531 190.239L33.895 189.841Z",
    fill: "#192657"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.7992 387.6C14.5992 387.6 8.69922 393.5 8.69922 400.7C8.69922 408.6 21.7992 427 21.7992 427C21.7992 427 34.8992 408.4 34.8992 400.7C34.7992 393.4 28.9992 387.6 21.7992 387.6ZM21.7992 404.1C19.0992 404.1 16.8992 401.9 16.8992 399.2C16.8992 396.5 19.0992 394.3 21.7992 394.3C24.4992 394.3 26.6992 396.5 26.6992 399.2C26.6992 401.9 24.4992 404.1 21.7992 404.1Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6992 341.8V345.4C51.6992 348.7 54.2992 351.3 57.5992 351.3H96.1992",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6992 341.8V345.4C51.6992 348.7 54.2992 351.3 57.5992 351.3H96.1992",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8992 341.8V298H101.499V346C101.499 348.9 99.0992 351.3 96.1992 351.3C93.2992 351.3 90.8992 348.9 90.8992 346V341.8H51.6992",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8992 341.8V298H101.499V346C101.499 348.9 99.0992 351.3 96.1992 351.3C93.2992 351.3 90.8992 348.9 90.8992 346V341.8H51.6992",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 308H90.9",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 328.9H90.9",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 321.9H90.9",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 315H84.2",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.2 327.9C7.2 329.3 6 330.5 4.6 330.5C3.2 330.5 2 329.3 2 327.9C2 326.5 3.2 325.3 4.6 325.3C6.1 325.4 7.2 326.5 7.2 327.9Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.8008 377.2H121.501",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.9 368.1H120.3",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 275.5H34.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 266.4H33.4992",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334 275.5H1363.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.2 266.4H1362.5",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M209.7 536.333C208.7 536.333 207.8 535.933 207.1 535.233L195.3 523.433C193.9 522.033 193.9 519.633 195.3 518.233C196.7 516.833 199.1 516.833 200.5 518.233L209.3 527.033L223 509.433C224.3 507.833 226.6 507.533 228.2 508.733C229.8 510.033 230.1 512.333 228.9 513.933L212.7 534.933C212 535.733 211.1 536.333 210 536.333C209.9 536.333 209.8 536.333 209.7 536.333Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181 519.733H172",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M212.299 552.733H203.299",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 30.3C1139.5 27.4 1140.6 24.1 1140.6 20.5C1140.6 10.3 1132.3 2.00001 1122.1 2.00001C1111.9 2.00001 1103.6 10.3 1103.6 20.5C1103.6 30.7 1111.9 39 1122.1 39C1125.1 39 1127.9 38.3 1130.4 37C1134 39.8 1139.3 39.6 1142.6 36.3C1142.8 36.1 1143 35.9 1143.1 35.7L1137.7 30.3Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 14C1089.8 14 1081.5 22.3 1081.5 32.5C1081.5 36.1 1082.6 39.5 1084.4 42.3L1079 47.7C1079.2 47.9 1079.3 48.1 1079.5 48.3C1082.8 51.6 1088.1 51.9 1091.7 49C1094.2 50.2 1097 51 1100 51C1110.2 51 1118.5 42.7 1118.5 32.5C1118.5 22.3 1110.2 14 1100 14Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094 33.2001C1094 34.4001 1093 35.3001 1091.9 35.3001C1090.7 35.3001 1089.8 34.3001 1089.8 33.2001C1089.8 32.1001 1090.8 31.1001 1091.9 31.1001C1093 31.1001 1094 32.0001 1094 33.2001Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.2 33.2001C1102.2 34.4001 1101.2 35.3001 1100.1 35.3001C1098.9 35.3001 1098 34.3001 1098 33.2001C1098 32.1001 1099 31.1001 1100.1 31.1001C1101.2 31.1001 1102.2 32.0001 1102.2 33.2001Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.4 33.2001C1110.4 34.4001 1109.4 35.3001 1108.3 35.3001C1107.1 35.3001 1106.2 34.3001 1106.2 33.2001C1106.2 32.1001 1107.2 31.1001 1108.3 31.1001C1109.4 31.1001 1110.4 32.0001 1110.4 33.2001Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.7 20.4998C1116.7 21.3998 1115.9 22.1998 1115 22.1998C1114.1 22.1998 1113.3 21.3998 1113.3 20.4998C1113.3 19.5998 1114.1 18.7998 1115 18.7998C1115.9 18.7998 1116.7 19.4998 1116.7 20.4998Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.2 20.4998C1123.2 21.3998 1122.4 22.1998 1121.5 22.1998C1120.6 22.1998 1119.8 21.3998 1119.8 20.4998C1119.8 19.5998 1120.6 18.7998 1121.5 18.7998C1122.5 18.7998 1123.2 19.4998 1123.2 20.4998Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.7 20.4998C1129.7 21.3998 1128.9 22.1998 1128 22.1998C1127.1 22.1998 1126.3 21.3998 1126.3 20.4998C1126.3 19.5998 1127.1 18.7998 1128 18.7998C1128.9 18.7998 1129.7 19.4998 1129.7 20.4998Z",
    fill: "#192657"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.7 30.3C308.5 27.4 309.6 24.1 309.6 20.5C309.6 10.3 301.3 2.00001 291.1 2.00001C280.9 2.00001 272.6 10.3 272.6 20.5C272.6 30.7 280.9 39 291.1 39C294.1 39 296.9 38.3 299.4 37C303 39.8 308.3 39.6 311.6 36.3C311.8 36.1 312 35.9 312.1 35.7L306.7 30.3Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 14C258.8 14 250.5 22.3 250.5 32.5C250.5 36.1 251.6 39.5 253.4 42.3L248 47.7C248.2 47.9 248.3 48.1 248.5 48.3C251.8 51.6 257.1 51.9 260.7 49C263.2 50.2 266 51 269 51C279.2 51 287.5 42.7 287.5 32.5C287.5 22.3 279.2 14 269 14Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.001 33.2001C263.001 34.4001 262.001 35.3001 260.901 35.3001C259.701 35.3001 258.801 34.3001 258.801 33.2001C258.801 32.1001 259.801 31.1001 260.901 31.1001C262.001 31.1001 263.001 32.0001 263.001 33.2001Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2 33.2001C271.2 34.4001 270.2 35.3001 269.1 35.3001C267.9 35.3001 267 34.3001 267 33.2001C267 32.1001 268 31.1001 269.1 31.1001C270.2 31.1001 271.2 32.0001 271.2 33.2001Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.401 33.2001C279.401 34.4001 278.401 35.3001 277.301 35.3001C276.101 35.3001 275.201 34.3001 275.201 33.2001C275.201 32.1001 276.201 31.1001 277.301 31.1001C278.401 31.1001 279.401 32.0001 279.401 33.2001Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.701 20.4998C285.701 21.3998 284.901 22.1998 284.001 22.1998C283.101 22.1998 282.301 21.3998 282.301 20.4998C282.301 19.5998 283.101 18.7998 284.001 18.7998C284.901 18.7998 285.701 19.4998 285.701 20.4998Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.201 20.4998C292.201 21.3998 291.401 22.1998 290.501 22.1998C289.601 22.1998 288.801 21.3998 288.801 20.4998C288.801 19.5998 289.601 18.7998 290.501 18.7998C291.501 18.7998 292.201 19.4998 292.201 20.4998Z",
    fill: "#192657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.701 20.4998C298.701 21.3998 297.901 22.1998 297.001 22.1998C296.101 22.1998 295.301 21.3998 295.301 20.4998C295.301 19.5998 296.101 18.7998 297.001 18.7998C297.901 18.7998 298.701 19.4998 298.701 20.4998Z",
    fill: "#192657"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1350.6 83.3002L1359.4 67.3002C1361.1 64.2002 1361.6 60.7002 1361 57.3002C1359.6 50.3002 1353.5 45.2002 1346.3 45.2002H1342.8H1347.5H1344C1336.8 45.2002 1330.7 50.3002 1329.3 57.3002C1328.6 60.7002 1329.2 64.3002 1330.9 67.3002L1339.7 83.3002H1350.6Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.1 87.1004V65.1004C1343.1 63.6004 1341.9 62.4004 1340.4 62.4004C1338.9 62.4004 1337.7 63.6004 1337.7 65.1004V65.5004C1337.7 67.0004 1338.9 68.2004 1340.4 68.2004H1347.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.3 87.1004V65.1004C1347.3 63.6004 1348.5 62.4004 1350 62.4004C1351.5 62.4004 1352.7 63.6004 1352.7 65.1004V65.5004C1352.7 67.0004 1351.5 68.2004 1350 68.2004H1342.7",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1348.6 88.1998H1341.7C1340.2 88.1998 1339 86.9998 1339 85.4998C1339 83.9998 1340.2 82.7998 1341.7 82.7998H1348.6C1350.1 82.7998 1351.3 83.9998 1351.3 85.4998C1351.3 86.9998 1350.1 88.1998 1348.6 88.1998Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1348.6 82.9004H1341.7C1340.2 82.9004 1339 84.1004 1339 85.6004C1339 87.1004 1340.2 88.3004 1341.7 88.3004H1348.6C1350.1 88.3004 1351.3 87.1004 1351.3 85.6004C1351.3 84.1004 1350.1 82.9004 1348.6 82.9004Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1348.6 88.2002H1341.7C1340.2 88.2002 1339 89.4002 1339 90.9002C1339 92.4002 1340.2 93.6002 1341.7 93.6002H1348.6C1350.1 93.6002 1351.3 92.4002 1351.3 90.9002C1351.3 89.4002 1350.1 88.2002 1348.6 88.2002Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1271 38.2L1277.5 37.3L1276.5 29.7L1270 30.6C1269.8 30 1269.5 29.3 1269.3 28.7L1274.6 25L1270.2 18.8L1264.9 22.5C1264.4 22 1263.9 21.6 1263.4 21.1L1266.4 15.3L1259.6 11.8L1256.6 17.6C1255.7 17.3 1254.7 17.1 1253.7 17V10H1246.1V17.4C1245.4 17.6 1244.7 17.8 1244 18L1240.7 12.4L1234.1 16.3L1237.4 21.9C1236.9 22.4 1236.4 22.8 1235.9 23.3L1230.4 19.9L1226.4 26.4L1231.9 29.8C1231.7 30.4 1231.4 31.1 1231.3 31.7L1224.8 31.2L1224.2 38.8L1230.7 39.3C1230.8 40 1230.9 40.7 1231 41.3L1225 43.8L1228 50.8L1234 48.3C1234.4 48.9 1234.8 49.4 1235.2 50L1231.1 55L1237 59.9L1241.1 54.9C1241.7 55.2 1242.3 55.5 1243 55.8L1241.6 62.2L1249.1 63.8L1250.5 57.4C1250.6 57.4 1250.8 57.4 1251 57.4C1251.5 57.4 1252.1 57.4 1252.6 57.3L1254.3 63.6L1261.7 61.6L1260 55.3C1260.6 55 1261.2 54.7 1261.8 54.3L1266.2 59.1L1271.8 53.9L1267.4 49.1C1267.8 48.6 1268.2 48 1268.5 47.4L1274.6 49.6L1277.2 42.4L1271.1 40.2C1270.9 39.6 1271 38.9 1271 38.2ZM1250.7 48C1244.7 48 1239.9 43.2 1239.9 37.2C1239.9 31.2 1244.7 26.4 1250.7 26.4C1256.7 26.4 1261.5 31.2 1261.5 37.2C1261.5 43.1 1256.7 48 1250.7 48Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.5 37.0998C1261.5 43.0998 1256.7 47.8998 1250.7 47.8998C1244.7 47.8998 1239.9 43.0998 1239.9 37.0998C1239.9 31.0998 1244.7 26.2998 1250.7 26.2998C1256.7 26.2998 1261.5 31.0998 1261.5 37.0998Z",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1296.4 12.8998C1296.4 14.2998 1295.2 15.4998 1293.8 15.4998C1292.4 15.4998 1291.2 14.2998 1291.2 12.8998C1291.2 11.4998 1292.4 10.2998 1293.8 10.2998C1295.3 10.2998 1296.4 11.4998 1296.4 12.8998Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1238.3 80.4004H1229.3",
    stroke: "#192657",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBg);
export default __webpack_public_path__ + "static/media/home_bg.ecc3ea204b54d588d1f156f79b0533da.svg";
export { ForwardRef as ReactComponent };